import { useEffect, useState } from "react";
import { docManager, type DocHandle } from "../sync/docManager";

/**
 * The core docs of several workspaces at once (ADR 0024: the combined view). Each is opened once through the doc
 * manager, which syncs any number of docs; a doc that is not restored yet is simply missing from the result.
 */
export function useWorkspaceDocs(workspaceIds: string[]): Record<string, DocHandle> {
  const key = workspaceIds.join(",");
  const [handles, setHandles] = useState<Record<string, DocHandle>>({});
  useEffect(() => {
    let alive = true;
    for (const id of key ? key.split(",") : []) {
      void docManager.open(`${id}:core`).then((h) => {
        if (alive) setHandles((cur) => (cur[id] === h ? cur : { ...cur, [id]: h }));
      });
    }
    return () => {
      alive = false;
    };
  }, [key]);
  return handles;
}
